module.exports = __webpack_public_path__ + "static/media/cms-solutions-icon.2b7b52bf.svg";